import { Outlet, Link } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import ConditionalLayout from "./conditional-layout";
function Layout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const auth = useAuth();
  const handleLogout = () => {
    auth.removeUser();
  };
  return (
    <div>
      <ConditionalLayout>{children}</ConditionalLayout>
      <main style={{ padding: "2rem" }}>
        <Outlet />
      </main>
    </div>
  );
}
export default Layout;
